<template>
    <div class="product-video-container" id="product-video-container">
      <div class="product-video" id="product-video">
        <div
            class="video-js-container vjs-default-skin"
            :with_theatrical_btn="false"
            :data-sources="JSON.stringify(hlsSources)"
            :data-poster="poster"
            :data-text_tracks="JSON.stringify(textTracks)"
            :data-id="uploadedVideo.id"
            :holder="JSON.stringify(holderData)"
        >
          <video
            ref="videoPlayer"
            class="video-js"
            :controls="true"
            preload="auto"
            width="100%"
            height="100%"
            :poster="poster"
          >
            <!-- EXACT MATCH TO HAML -->
            <!-- <source
              v-for="(src, i) in hlsSources"
              :key="i"
              :src="src"
              type="application/x-mpegURL"
            /> -->
            <source
              :src="hlsSources[0]"
              type="application/x-mpegURL"
            />
  
            <track
              v-for="(track, i) in textTracks"
              :key="i"
              :kind="track.kind"
              :src="track.src"
              :srclang="track.srclang"
              :label="track.label"
            />
          </video>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      content: {
        type: Object,
        default: () => ({})
      }
    },
  
    data() {
      return {
        player: null
      }
    },
  
    computed: {
      uploadedVideo() {
        return this.content.uploaded_video || {}
      },
  
      hlsSources() {
        return this.uploadedVideo.hls_sources || []
      },
  
      textTracks() {
        return this.uploadedVideo.text_tracks || []
      },
  
      poster() {
        return (
          this.uploadedVideo?.poster?.md ||
          this.content?.video_poster?.url ||
          this.content?.logo_image ||
          ""
        )
      },
  
      hasVideo() {
        return this.hlsSources.length > 0
      },

      holderData() {
        return {
            class: 'cards',
            id: this.content.id,
            type: this.content.type,
            title: this.content.title
        }
    }
    },
  
    mounted() {
      if (!this.hasVideo) return
    //   this.initVideoJs()
    },
  
    beforeDestroy() {
      if (this.player) {
        this.player.dispose()
        this.player = null
      }
    },
  
    methods: {
        loadVideoJs() {
            return new Promise((resolve, reject) => {
                if (window.videojs) return resolve()

                const script = document.createElement("script")
                script.src = "https://vjs.zencdn.net/8.10.0/video.min.js"

                script.onload = () => resolve(window.videojs)
                script.onerror = reject

                document.body.appendChild(script)
            })
        },
  
        async initVideoJs() {
            if (!this.hlsSources.length) return

            await this.loadVideoJs()

            const videojs = window.videojs

            if (typeof videojs !== 'function') {
                console.error('Video.js not loaded correctly', videojs)
                return
            }

            this.player = videojs(this.$refs.videoPlayer, {
                controls: true,
                fluid: true,
                responsive: true,
                preload: 'auto',
                poster: this.poster,
                sources: [
                {
                    src: this.hlsSources[0],
                    type: 'application/x-mpegURL'
                }
                ]
            })

            this.player.ready(() => {
                this.player.pause()
            })
        }
    }
  }
  </script>
  
  <style lang="scss">
  .product-video-container {
    width: 100%;
    height: 100%;
  }
  
  .product-video {
    width: 100%;
    height: 100%;
    position: relative;
  }
  
  .video-js-container {
    width: 100%;
    height: 100%;
    position: relative;
  }
  
  .video-js {
    width: 100% !important;
    height: 100% !important;
  }
  
  .video-js .vjs-tech {
    object-fit: cover;
  }
  </style>